import React from 'react';
import {
  Paper, Typography, Box, Skeleton,  Chip, 
  IconButton, Stack, useTheme, Divider, Grid
} from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useHistory } from 'react-router-dom';
import CalendarButton from "../../../components/common/CalendarButton";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
// --- UTILITY FUNCTIONS (Fuori dal componente per pulizia e performance) ---

const FormazioneRiepilogo = ({t, data, loading, onYearChange }) => {
  const theme = useTheme();
  const history = useHistory();
  const [selectedYear, setSelectedYear] = React.useState(new Date().getFullYear());
  const handlePrevYear = () => {
    const prev = selectedYear - 1;
    setSelectedYear(prev);
    onYearChange(prev); // Avvisa il padre di scaricare i nuovi dati
  };

  const handleNextYear = () => {
    const next = selectedYear + 1;
    setSelectedYear(next);
    onYearChange(next); // Avvisa il padre di scaricare i nuovi dati
  };

  const getStatusColor = (type) => {
    if (type === 'fatto') return '#2e7d32'; // Verde
    if (type === 'programma') return '#0288d1'; // Blu 
    if (type === 'istruttore') return '#03a9f4'; // Azzurro
    return '#ccc';
  };

  const RenderCorsoCard = ({ item, type }) => (
    <Box 
      onClick={() => {
        const date = new Date(item.giorno);
        history.push("/app/formazione", { targetYear: date.getFullYear(), targetMonth: date.getMonth(), targetEventId: item.id });
      }}
      sx={{
        p: 1.5,
        mb: 1,
        cursor: 'pointer',
        borderRadius: '8px',
        bgcolor: '#fff',
        border: '1px solid #edf2f7',
        borderLeft: `5px solid ${getStatusColor(type)}`, // IL TUO COLORE IDENTIFICATIVO
        transition: 'transform 0.1s, box-shadow 0.1s',
        '&:hover': { boxShadow: '0 4px 12px rgba(0,0,0,0.05)', transform: 'translateX(4px)' },
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
        <Box sx={{ flexGrow: 1, mr: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 700, color: '#2d3748', lineHeight: 1.3 }}>
            {item.descrizione}
          </Typography>
          
          <Stack direction="row" spacing={1.5} sx={{ mt: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', color: 'text.secondary' }}>
              <CalendarMonthIcon sx={{ fontSize: 13, mr: 0.5 }} />
              <Typography variant="caption">{new Date(item.giorno).toLocaleDateString('it-IT')}</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', color: 'text.secondary' }}>
              <AccessTimeIcon sx={{ fontSize: 13, mr: 0.5 }} />
              <Typography variant="caption" sx={{ fontWeight: 'bold' }}>{item.orePreviste}h</Typography>
            </Box>
          </Stack>
        </Box>

        {type !== 'fatto' && !item.isInCoda && (
           <Box onClick={e => e.stopPropagation()} sx={{ minWidth: '40px' }}>
              <CalendarButton
                data={{
                  title: item.descrizione || 'Evento Formazione',
                  start: new Date(item.giorno),
                  end: new Date(new Date(item.giorno).getTime() + 24 * 60 * 60 * 1000),
                  description: item.descrizione || '',
                  location: ''
                }}
                filename={`formazione_${item.id}.ics`}
                t={t}
                buttonProps={{
                  size: 'small',
                  sx: {
                    color: "#2c5282",
                    "&:hover": {
                      backgroundColor: "#2c5282",
                      color: "#fff",
                    },
                  }
                }}
              />
           </Box>
        )}
      </Stack>
      {item.isInCoda && <Chip label="In coda" size="small" variant="outlined" sx={{ mt: 1, height: 18, fontSize: '0.6rem' }} />}
    </Box>
  );

  return (
    <Paper id="home-riepilogo" elevation={0} sx={{ borderRadius: 3, border: '1px solid #e2e8f0', overflow: 'hidden', bgcolor: '#f8fafc' }}>
      {/* Header PRO */}
      <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#fff' }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <SchoolIcon sx={{ color: '#1a365d' }} />
          <Typography variant="subtitle1" sx={{ fontWeight: 800, color: '#1a365d', textTransform: 'uppercase', letterSpacing: 1 }}>
            {t("Formazione")}
          </Typography>
        </Stack>
        
        <Box sx={{ display: 'flex', alignItems: 'center', bgcolor: '#edf2f7', borderRadius: '20px', px: 1 }}>
          <IconButton size="small" onClick={handlePrevYear} disabled={selectedYear <= 2025}><ChevronLeftIcon fontSize="small" /></IconButton>
          <Typography sx={{ fontWeight: 800, mx: 1, fontSize: '0.85rem' }}>{selectedYear}</Typography>
          <IconButton size="small" onClick={handleNextYear} disabled={selectedYear >= new Date().getFullYear() + 1}><ChevronRightIcon fontSize="small" /></IconButton>
        </Box>
      </Box>

      <Divider />

      <Box sx={{ p: 1.5 }}>
        {loading ? (
          <Box>
            {/* Simula il grafico o le barre della formazione */}
            <Skeleton variant="text" width="100%" height={30} />
            <Skeleton variant="rectangular" height={150} sx={{ my: 2, borderRadius: 2 }} />
          </Box>
        ) : (
          <Grid container spacing={2}>
            {/* Colonna Programmati / Istruttore */}
            <Grid item xs={12} md={6}>
               {data.daFare.length > 0 && (
                 <Box sx={{ mb: 2 }}>
                   <Typography variant="caption" sx={{ fontWeight: 900, color: '#0288d1', ml: 1, mb: 1, display: 'block' }}>DA FREQUENTARE</Typography>
                   {data.daFare.map(c => <RenderCorsoCard key={c.id} item={c} type="programma" />)}
                 </Box>
               )}
               {data.istruttore.length > 0 && (
                 <Box>
                   <Typography variant="caption" sx={{ fontWeight: 900, color: '#03a9f4', ml: 1, mb: 1, display: 'block' }}>DOCENZE</Typography>
                   {data.istruttore.map(c => <RenderCorsoCard key={c.id} item={c} type="istruttore" />)}
                 </Box>
               )}
            </Grid>

            {/* Colonna Completati */}
            <Grid item xs={12} md={6}>
               {data.fatti.length > 0 && (
                 <Box>
                   <Typography variant="caption" sx={{ fontWeight: 900, color: '#2e7d32', ml: 1, mb: 1, display: 'block' }}>STORICO COMPLETATI</Typography>
                   {data.fatti.map(c => <RenderCorsoCard key={c.id} item={c} type="fatto" />)}
                 </Box>
               )}
            </Grid>
          </Grid>
        )}
      </Box>

      {/* Footer Riepilogo Ore - Versione High Contrast */}
      <Box sx={{ 
        p: 2, 
        bgcolor: '#1a365d', // Il tuo blu notte
        color: '#fff', 
        display: 'flex', 
        justifyContent: 'space-around',
        borderTop: '4px solid #cbd5e0'
      }}>
        <Box textAlign="center">
          {/* 1. Aumentiamo l'opacità e usiamo un bianco puro o un azzurro chiarissimo */}
          <Typography sx={{ 
            fontSize: '0.7rem', 
            fontWeight: 800, 
            letterSpacing: 1.2,
            color: '#90caf9', // Azzurro chiaro per l'etichetta (stacca bene sul blu)
            mb: 0.5,
            textTransform: 'uppercase'
          }}>
            ORE TOTALI
          </Typography>
          <Typography variant="h4" sx={{ fontWeight: 900, color: '#fff' }}>
            {data.oreTot}
          </Typography>
        </Box>

        {data.oreIstr > 0 && (
          <Box textAlign="center">
            <Typography sx={{ 
              fontSize: '0.7rem', 
              fontWeight: 800, 
              letterSpacing: 1.2,
              color: '#90caf9', // Stesso azzurro per coerenza
              mb: 0.5,
              textTransform: 'uppercase'
            }}>
              ORE DOCENZA
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: 900, color: '#64b5f6' }}>
              {data.oreIstr}
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default FormazioneRiepilogo;